import React from 'react';
import {
  Svg, Defs, G, LinearGradient, Path, RadialGradient, Stop,
} from 'react-native-svg';

function CustomVanSVG({ color }) {
  return (
    <Svg
      id="svg602"
      version="1.1"
    >
      <Defs
        id="defs604"
      >
        <LinearGradient
          id="linearGradient624"
        >
          <Stop
            id="stop625"
            stopColor="#ffffff"
            offset="0"
          />
          <Stop
            id="stop626"
            stopColor="#000047"
            offset="1"
          />
        </LinearGradient>
        <LinearGradient
          id="linearGradient621"
        >
          <Stop
            id="stop622"
            stopColor="#ffffff"
            offset="0"
          />
          <Stop
            id="stop623"
            stopColor="#0007ee"
            offset="1"
          />
        </LinearGradient>
        <RadialGradient
          id="radialGradient618"
          gradientUnits="userSpaceOnUse"
          cy="148.78"
          cx="532.17999"
          gradientTransform="scale(0.70711,1.4142)"
          r="26.945999"
        />
        <LinearGradient
          id="linearGradient619"
          y2="112.53"
          spreadMethod="reflect"
          gradientUnits="userSpaceOnUse"
          y1="112.53"
          gradientTransform="scale(0.70711,1.4142)"
          x2="548.53003"
          x1="530.07001"
        >
          <Stop
            id="stop616"
            stopColor="#7f7f7f"
            offset="0"
          />
          <Stop
            id="stop617"
            stopColor="#191919"
            offset="1"
          />
        </LinearGradient>
        <RadialGradient
          id="radialGradient627"
          gradientUnits="userSpaceOnUse"
          cy="78.647003"
          cx="532.12"
          gradientTransform="scale(0.70711,1.4142)"
          r="32.632"
        />
        <LinearGradient
          id="linearGradient643"
          y2="620.63"
          gradientUnits="userSpaceOnUse"
          y1="792.88"
          gradientTransform="matrix(2.7566,0,0,0.36277,-16.25,-47.5)"
          x2="107.57"
          x1="152.10001"
        />
        <RadialGradient
          id="radialGradient644"
          gradientUnits="userSpaceOnUse"
          cy="109.49"
          cx="563.96002"
          gradientTransform="matrix(0.66871,0,0,1.4954,-16.25,-47.5)"
          r="116.01"
        />
        <RadialGradient
          id="radialGradient725"
          spreadMethod="reflect"
          gradientUnits="userSpaceOnUse"
          cy="73.640999"
          cx="44.298"
          r="14.706"
        />
        <LinearGradient
          id="linearGradient3019"
          y2="91.490997"
          gradientUnits="userSpaceOnUse"
          x2="107.56"
          gradientTransform="matrix(2.7564,0,0,0.3628,-16.25,-47.5)"
          y1="263.75"
          x1="152.09"

        />
        <LinearGradient
          id="ButtonShadow-5"
          y2="7.0165"
          gradientUnits="userSpaceOnUse"
          x2="45.448002"
          gradientTransform="scale(1.0059,0.99417)"
          y1="92.540001"
          x1="45.448002"
        >
          <Stop
            id="stop3750-6"
            stopColor="#000000"
            offset="0"
          />
          <Stop
            id="stop3752-8"
            stopColor="#000000"
            stopOpacity=".58824"
            offset="1"
          />
        </LinearGradient>
        <LinearGradient
          id="linearGradient3360-0"
          y2="59"
          gradientUnits="userSpaceOnUse"
          x2="75.25"
          gradientTransform="translate(0,-1)"
          y1="59"
          x1="68.75"
        />
        <LinearGradient
          id="linearGradient3354-9"
        >
          <Stop
            id="stop3356-5"
            stopColor="#b4b4b4"
            offset="0"
          />
          <Stop
            id="stop3362-8"
            stopColor="#646464"
            offset=".20467"
          />
          <Stop
            id="stop3364-0"
            stopColor="#ffffff"
            offset=".49568"
          />
          <Stop
            id="stop3358-7"
            stopColor="#3c3c3c"
            offset="1"
          />
        </LinearGradient>
        <LinearGradient
          id="linearGradient5495"
          y2="54"
          gradientUnits="userSpaceOnUse"
          x2="73"
          gradientTransform="translate(0,-1)"
          y1="54"
          x1="69"
        >
          <Stop
            id="stop3292-1"
            stopColor="#ffffff"
            offset="0"
          />
          <Stop
            id="stop3304-9"
            stopColor="#8c8c8c"
            offset=".48973"
          />
          <Stop
            id="stop3306-0"
            stopColor="#cfcfcf"
            offset=".50045"
          />
          <Stop
            id="stop3298-9"
            stopColor="#ffffff"
            offset=".62277"
          />
          <Stop
            id="stop3300-9"
            stopColor="#c8c8c8"
            offset=".81696"
          />
          <Stop
            id="stop3294-9"
            stopColor="#505050"
            offset="1"
          />
        </LinearGradient>
        <LinearGradient
          id="linearGradient5497"
          y2="54"
          gradientUnits="userSpaceOnUse"
          x2="73"
          gradientTransform="matrix(-1,0,0,1,144,-4)"
          y1="54"
          x1="69"
        >
          <Stop
            id="stop3606-9"
            stopColor="#2f2f2f"
            offset="0"
          />
          <Stop
            id="stop3608-8"
            stopColor="#ffffff"
            offset=".43731"
          />
          <Stop
            id="stop3610-9"
            stopColor="#979797"
            offset=".62138"
          />
          <Stop
            id="stop3612-7"
            stopColor="#505050"
            offset=".77232"
          />
          <Stop
            id="stop3614-1"
            stopColor="#e6e6e6"
            offset="1"
          />
        </LinearGradient>
        <LinearGradient
          id="linearGradient3516-8"
          y2="17.763"
          gradientUnits="userSpaceOnUse"
          x2="75.971001"
          gradientTransform="translate(0,-2)"
          y1="17.763"
          x1="68.028999"
        />
        <LinearGradient
          id="linearGradient3435-1"
        >
          <Stop
            id="stop3437-7"
            stopColor="#ededed"
            offset="0"
          />
          <Stop
            id="stop3439-9"
            stopColor="#b0b0b0"
            offset="1"
          />
        </LinearGradient>
        <LinearGradient
          id="linearGradient3489-1"
          y2="17.5"
          gradientUnits="userSpaceOnUse"
          x2="75.061996"
          gradientTransform="matrix(-1,0,0,1,144.03,-2)"
          y1="17.5"
          x1="68.969002"
        />
        <LinearGradient
          id="linearGradient3530-8"
          y2="59"
          gradientUnits="userSpaceOnUse"
          x2="72.250999"
          gradientTransform="matrix(1.1263,0,0,1,-7.402,-49.5)"
          y1="59"
          x1="68.75"
        />
        <LinearGradient
          id="linearGradient3035-3"
          y2="138.71001"
          gradientUnits="userSpaceOnUse"
          x2="221.81"
          gradientTransform="matrix(2.2012,0,0,0.54931734,-215.80045,-32.658207)"
          y1="52.300999"
          x1="192.11"
        />
        <LinearGradient
          id="linearGradient757"
        >
          <Stop
            id="stop758"
            stopColor="#ffffff"
            offset="0"
          />
          <Stop
            id="stop759"
            stopColor="#00005f"
            offset="1"
          />
        </LinearGradient>
        <LinearGradient
          id="linearGradient3035-3-9"
          y2="138.71001"
          gradientUnits="userSpaceOnUse"
          x2="221.81"
          gradientTransform="matrix(2.2012,0,0,0.54931734,-283.80045,-32.658207)"
          y1="52.300999"
          x1="192.11"

        />
        <LinearGradient
          id="linearGradient3035-3-9-0"
          y2="138.71001"
          gradientUnits="userSpaceOnUse"
          x2="221.81"
          gradientTransform="matrix(2.2012,0,0,0.54931734,-351.80045,-32.658207)"
          y1="52.300999"
          x1="192.11"

        />
        <LinearGradient
          id="linearGradient3035-3-9-7"
          y2="138.71001"
          gradientUnits="userSpaceOnUse"
          x2="221.81"
          gradientTransform="matrix(0,-2.4137337,0.203968,0,-13.141365,565.89809)"
          y1="52.300999"
          x1="192.11"

        />
        <LinearGradient
          id="linearGradient3035-3-9-7-8"
          y2="138.71001"
          gradientUnits="userSpaceOnUse"
          x2="221.81"
          gradientTransform="matrix(0,2.4137337,0.203968,0,-12.997883,-339.48368)"
          y1="52.300999"
          x1="192.11"

        />
        <LinearGradient

          id="linearGradient3162"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(2.2012,0,0,0.54931734,-215.80045,-32.658207)"
          x1="192.11"
          y1="52.300999"
          x2="221.81"
          y2="138.71001"
        />
        <LinearGradient

          id="linearGradient3164"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(2.2012,0,0,0.54931734,-283.80045,-32.658207)"
          x1="192.11"
          y1="52.300999"
          x2="221.81"
          y2="138.71001"
        />
        <LinearGradient

          id="linearGradient3166"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(2.2012,0,0,0.54931734,-351.80045,-32.658207)"
          x1="192.11"
          y1="52.300999"
          x2="221.81"
          y2="138.71001"
        />
      </Defs>
      <G
        id="g868"
        transform="rotate(-90,236.21602,236.21602)"
      >
        <Path
          d="M 2.5,227.5 445,229 c 12.29,-1.25 15.6425,-15.47375 21.75,-29.78625 C 472.085,182.78125 471.04,47.5 465.63,32.5 460.83,19.375 456.04,2.5 443.75,2.5 H 2.5 Z"
          fill={color}
          fillOpacity="1"
          fillRule="evenodd"
          stroke="#000000"
          strokeWidth="5"
          strokeLinejoin="round"

          id="path721"
        />
        <Path
          d="m 348.77,29.655 c -3.69,0.697 -6.93,2.229 -7.07,5.852 3.83,54.073 3.68,105.7 -1.77,159.77 0,3.35 3.09,5.9 5.3,5.9 l 61.87,6.57 c 4.71,0.44 9.57,-3.25 10.61,-7.53 5.33,-55.95 5.66,-114.27 -0.88,-171.4 0.14,-4.177 -5.05,-8.007 -9.73,-6.689 l -58.33,7.524 z"
          fill="url(#radialGradient644)"
          stroke="#000000"
          strokeWidth="2.43149996"

          id="path690"
        />
        <Path
          d="m 449.08806,213.2199 c 11.92842,0 10.97521,-73.92858 10.75014,-90.54148 0.38394,-17.62932 1.74757,-100.094501 -9.92932,-100.031415 0,24.268625 -0.38394,169.960985 -0.82082,190.569405 z"
          fill="#595959"
          fillOpacity="1"
          fillRule="evenodd"
          strokeWidth="1.2436614"

          id="path723"
        />
        <G
          transform="matrix(1.2484934,0,0,0.83684578,-71.160449,-19.707876)"
          id="g729"
        >
          <Path
            d="m 66.291,62.36 h 218.32"

            fill="none"
            stroke="#000000"
            strokeWidth="1.00000003pt"
            id="path727"
          />
          <Path
            d="m 66.291,261.3 h 218.32"

            fill="none"
            stroke="#000000"
            id="path728"
          />
        </G>
        <Path
          d="m 329.73,25.466 c -6.08,0.625 -44.98,1.875 -46.85,0 -1.87,-2.258 -1.87,-10.611 0,-11.932 l 113.25,-0.857 c 7.72,-0.081 7.79,3.433 4.41,4.446 -6.25,1.719 -64.13,7.906 -70.81,8.343 z"
          fill="url(#linearGradient3019)"
          fillRule="evenodd"
          stroke="#000000"
          strokeWidth="2.5"
          strokeLinejoin="bevel"

          id="path736"
        />
        <Path
          d="m 329.79,205.61 c -6.08,-0.62 -44.98,-1.87 -46.85,0 -1.87,2.26 -1.87,10.61 0,11.94 l 113.25,0.85 c 7.72,0.08 7.79,-3.43 4.41,-4.44 -6.25,-1.72 -64.13,-7.91 -70.81,-8.35 z"
          fill="url(#linearGradient643)"
          fillRule="evenodd"
          stroke="#000000"
          strokeWidth="2.5"
          strokeLinejoin="bevel"

          id="path738"
        />
        <Path
          strokeOpacity="1"
          strokeLinejoin="miter"
          strokeLinecap="butt"
          strokeWidth="0.91745269px"
          stroke="#000000"
          fill="none"
          d="M 11.60342,31.923317 V 199.375"
          id="path2861"

        />
        <Path
          strokeOpacity="1"
          strokeLinejoin="miter"
          strokeLinecap="butt"
          strokeWidth="1px"
          stroke="#000000"
          fill="none"
          d="M 11.603427,198.95993 5,225.125"
          id="path2865"

        />
        <Path
          strokeOpacity="1"
          strokeLinejoin="miter"
          strokeLinecap="butt"
          strokeWidth="1px"
          stroke="#000000"
          fill="none"
          d="M 11.43,112.72345 H 3.35018"
          id="path2867"

        />
        <Path
          strokeOpacity="1"
          strokeLinejoin="miter"
          strokeLinecap="butt"
          strokeWidth="1px"
          stroke="#000000"
          fill="none"
          d="M 11.60342,31.923317 5.1875,5.1875"
          id="path2873"

        />
        <G
          id="g3088"
        >
          <Path
            id="path804-5"

            strokeLinejoin="bevel"
            strokeWidth="2.65611768"
            stroke="#000000"
            fillRule="evenodd"
            fill="url(#linearGradient3035-3)"
            d="m 270.35855,25.892516 c 1.06,-2.731472 1.64,-10.941608 0.59,-12.538897 l -60.59,0.106405 c -4.34,-0.09673 -3.36,12.281348 0.39,12.809747 6.71,0 58.57,1.889903 59.61,-0.377255 z"
          />
          <Path
            id="path804-5-8"

            strokeLinejoin="bevel"
            strokeWidth="2.65611768"
            stroke="#000000"
            fillRule="evenodd"
            fill="url(#linearGradient3035-3-9)"
            d="m 202.35855,25.892516 c 1.06,-2.731472 1.64,-10.941608 0.59,-12.538897 l -60.59,0.106405 c -4.34,-0.09673 -3.36,12.281348 0.39,12.809747 6.71,0 58.57,1.889903 59.61,-0.377255 z"
          />
          <Path
            id="path804-5-8-6"

            strokeLinejoin="bevel"
            strokeWidth="2.65611768"
            stroke="#000000"
            fillRule="evenodd"
            fill="url(#linearGradient3035-3-9-0)"
            d="m 134.35855,25.892516 c 1.06,-2.731472 1.64,-10.941608 0.59,-12.538897 l -60.59,0.106405 c -4.34,-0.09673 -3.36,12.281348 0.39,12.809747 6.71,0 58.57,1.889903 59.61,-0.377255 z"
          />
          <G
            id="g3077"
          >
            <Path
              strokeOpacity="1"
              strokeLinejoin="miter"
              strokeLinecap="butt"
              strokeWidth="1px"
              stroke="#000000"
              fill="none"
              d="M 69.25,26.75 H 12.625"
              id="path2973"

            />
            <Path
              strokeOpacity="1"
              strokeLinejoin="miter"
              strokeLinecap="butt"
              strokeWidth="1px"
              stroke="#000000"
              fill="none"
              d="M 68.25,23 H 11.625"
              id="path2975"

            />
            <Path
              strokeOpacity="1"
              strokeLinejoin="miter"
              strokeLinecap="butt"
              strokeWidth="1px"
              stroke="#000000"
              fill="none"
              d="M 66.25,12.75 H 9.125"
              id="path2977"

            />
            <Path
              strokeOpacity="1"
              strokeLinejoin="miter"
              strokeLinecap="butt"
              strokeWidth="1px"
              stroke="#000000"
              fill="none"
              d="m 66.875003,16 -56.875,0.0625"
              id="path2975-6"

            />
            <Path
              strokeOpacity="1"
              strokeLinejoin="miter"
              strokeLinecap="butt"
              strokeWidth="1px"
              stroke="#000000"
              fill="none"
              d="m 67.437503,19.625 h -56.6875"
              id="path2975-2"

            />
          </G>
        </G>
        <Path
          d="M 8.5992067,32.798728 C 7.5849799,31.636378 4.5364619,31.000368 3.9433689,32.151757 l 0.03951,66.440175 c -0.03591,4.759038 4.5602098,3.684408 4.7564108,-0.427669 0,-7.35786 0.7017423,-64.225126 -0.140081,-65.365535 z"
          strokeLinejoin="bevel"
          strokeWidth="1.69485128"
          stroke="#000000"
          fillRule="evenodd"
          fill="url(#linearGradient3035-3-9-7)"

          id="path804-5-8-9"
        />
        <Path
          d="m 8.7426874,193.61567 c -1.01423,1.16235 -4.06274,1.79836 -4.65584,0.64697 l 0.0395,-66.44017 c -0.0359,-4.75904 4.56021,-3.68441 4.75641,0.42767 0,7.35786 0.7017496,64.22512 -0.14008,65.36553 z"
          strokeLinejoin="bevel"
          strokeWidth="1.69485128"
          stroke="#000000"
          fillRule="evenodd"
          fill="url(#linearGradient3035-3-9-7-8)"

          id="path804-5-8-9-8"
        />
        <G
          transform="matrix(1,0,0,-1,0.00804248,232.01622)"
          id="g3088-9"
        >
          <Path
            id="path804-5-6"

            strokeLinejoin="bevel"
            strokeWidth="2.65611768"
            stroke="#000000"
            fillRule="evenodd"
            fill="url(#linearGradient3162)"
            d="m 270.35855,25.892516 c 1.06,-2.731472 1.64,-10.941608 0.59,-12.538897 l -60.59,0.106405 c -4.34,-0.09673 -3.36,12.281348 0.39,12.809747 6.71,0 58.57,1.889903 59.61,-0.377255 z"
          />
          <Path
            id="path804-5-8-0"

            strokeLinejoin="bevel"
            strokeWidth="2.65611768"
            stroke="#000000"
            fillRule="evenodd"
            fill="url(#linearGradient3164)"
            d="m 202.35855,25.892516 c 1.06,-2.731472 1.64,-10.941608 0.59,-12.538897 l -60.59,0.106405 c -4.34,-0.09673 -3.36,12.281348 0.39,12.809747 6.71,0 58.57,1.889903 59.61,-0.377255 z"
          />
          <Path
            id="path804-5-8-6-2"

            strokeLinejoin="bevel"
            strokeWidth="2.65611768"
            stroke="#000000"
            fillRule="evenodd"
            fill="url(#linearGradient3166)"
            d="m 134.35855,25.892516 c 1.06,-2.731472 1.64,-10.941608 0.59,-12.538897 l -60.59,0.106405 c -4.34,-0.09673 -3.36,12.281348 0.39,12.809747 6.71,0 58.57,1.889903 59.61,-0.377255 z"
          />
          <G
            id="g3077-7"
          >
            <Path
              strokeOpacity="1"
              strokeLinejoin="miter"
              strokeLinecap="butt"
              strokeWidth="1px"
              stroke="#000000"
              fill="none"
              d="M 69.25,26.75 H 12.625"
              id="path2973-6"

            />
            <Path
              strokeOpacity="1"
              strokeLinejoin="miter"
              strokeLinecap="butt"
              strokeWidth="1px"
              stroke="#000000"
              fill="none"
              d="M 68.25,23 H 11.625"
              id="path2975-1"

            />
            <Path
              strokeOpacity="1"
              strokeLinejoin="miter"
              strokeLinecap="butt"
              strokeWidth="1px"
              stroke="#000000"
              fill="none"
              d="M 66.25,12.75 H 9.125"
              id="path2977-3"

            />
            <Path
              strokeOpacity="1"
              strokeLinejoin="miter"
              strokeLinecap="butt"
              strokeWidth="1px"
              stroke="#000000"
              fill="none"
              d="m 66.875003,16 -56.875,0.0625"
              id="path2975-6-2"

            />
            <Path
              strokeOpacity="1"
              strokeLinejoin="miter"
              strokeLinecap="butt"
              strokeWidth="1px"
              stroke="#000000"
              fill="none"
              d="m 67.437503,19.625 h -56.6875"
              id="path2975-2-1"

            />
          </G>
        </G>
        <Path
          d="m 456.46345,51.454969 c 2.78267,42.810914 2.92033,85.622811 0.44247,128.435691 h 9.20348 c 2.19271,-42.8119 2.19271,-86.066269 0,-128.435691 l -9.64595,9.83e-4 z"
          strokeWidth="1.34758162"
          stroke="#000000"
          fillRule="evenodd"
          fill="#595959"

          id="path769"
        />
        <G
          id="g3224"
        >
          <Path

            id="path3199"
            d="m 465.69611,51.50831 -8.83884,-0.0221 -0.21664,-2.673712 -0.82192,-10.805511 -1.94454,-9.722718 -1.23744,-3.005204 -1.07423,-1.904067 -1.35,-2.165495 -2.4625,-2.834505 -2.375,-2.53125 -0.5,-10.71875 2.19326,0.089912 1.10486,0.7071068 2.38648,1.7235728 2.74004,2.5632614 2.47488,4.065864 2.38648,4.993942 1.98874,5.170718 1.76777,4.507806 1.67624,4.896566 0.71875,3.4375 0.46875,3.46875 0.34375,3.1875 0.34375,4.25 z"
            strokeOpacity="1"
            strokeLinejoin="miter"
            strokeLinecap="butt"
            strokeWidth="1px"
            stroke="#000000"
            fillOpacity="1"
            fill="#deffff"
          />
          <Path

            id="path3207"
            d="m 450.4,22.647005 5.37452,-8.37229"
            strokeOpacity="1"
            strokeLinejoin="miter"
            strokeLinecap="butt"
            strokeWidth="1px"
            stroke="#000000"
            fill="none"
          />
          <Path
            transform="rotate(90,236.21602,236.21602)"

            id="path3215"
            d="m 5.7382719,26.213343 c 0.077735,-0.710092 0.1733421,-0.921942 0.8685395,-1.924539 1.1197574,-1.614887 1.7162576,-2.34654 2.9771263,-3.651669 0.9316733,-0.964379 1.4074163,-1.330206 2.9044713,-2.233424 l 1.790301,-1.080141 3.364643,2.159852 3.364644,2.159852 -1.514194,1.31635 c -0.832806,0.723992 -2.031629,1.807002 -2.664051,2.406687 l -1.149858,1.090338 -0.787642,0.07084 c -0.433203,0.03896 -2.137643,0.128718 -3.787643,0.199464 -1.6499996,0.07074 -3.5520793,0.163659 -4.2268433,0.206474 l -1.2268439,0.07785 z"
            paintOrder="stroke markers fill"
            strokeOpacity="1"
            strokeDasharray="none"
            strokeMiterlimit="4"
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth="0.125"
            stroke="#000000"
            fillOpacity="1"
            fill="#f4a70d"
          />
        </G>
        <G
          transform="matrix(1,0,0,-1,0.48133,231.58328)"
          id="g3224-9"
        >
          <Path

            id="path3199-1"
            d="m 465.69611,51.50831 -8.83884,-0.0221 -0.21664,-2.673712 -0.82192,-10.805511 -1.94454,-9.722718 -1.23744,-3.005204 -1.07423,-1.904067 -1.35,-2.165495 -2.4625,-2.834505 -2.375,-2.53125 -0.5,-10.71875 2.19326,0.089912 1.10486,0.7071068 2.38648,1.7235728 2.74004,2.5632614 2.47488,4.065864 2.38648,4.993942 1.98874,5.170718 1.76777,4.507806 1.67624,4.896566 0.71875,3.4375 0.46875,3.46875 0.34375,3.1875 0.34375,4.25 z"
            strokeOpacity="1"
            strokeLinejoin="miter"
            strokeLinecap="butt"
            strokeWidth="1px"
            stroke="#000000"
            fillOpacity="1"
            fill="#deffff"
          />
          <Path

            id="path3207-0"
            d="m 450.4,22.647005 5.37452,-8.37229"
            strokeOpacity="1"
            strokeLinejoin="miter"
            strokeLinecap="butt"
            strokeWidth="1px"
            stroke="#000000"
            fill="none"
          />
          <Path
            transform="rotate(90,236.21602,236.21602)"

            id="path3215-7"
            d="m 5.7382719,26.213343 c 0.077735,-0.710092 0.1733421,-0.921942 0.8685395,-1.924539 1.1197574,-1.614887 1.7162576,-2.34654 2.9771263,-3.651669 0.9316733,-0.964379 1.4074163,-1.330206 2.9044713,-2.233424 l 1.790301,-1.080141 3.364643,2.159852 3.364644,2.159852 -1.514194,1.31635 c -0.832806,0.723992 -2.031629,1.807002 -2.664051,2.406687 l -1.149858,1.090338 -0.787642,0.07084 c -0.433203,0.03896 -2.137643,0.128718 -3.787643,0.199464 -1.6499996,0.07074 -3.5520793,0.163659 -4.2268433,0.206474 l -1.2268439,0.07785 z"
            paintOrder="stroke markers fill"
            strokeOpacity="1"
            strokeDasharray="none"
            strokeMiterlimit="4"
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth="0.125"
            stroke="#000000"
            fillOpacity="1"
            fill="#f4a70d"
          />
        </G>
        <Path
          strokeOpacity="1"
          strokeLinejoin="miter"
          strokeLinecap="butt"
          strokeWidth="0.99712157px"
          stroke="#ffffff"
          fillOpacity="1"
          fill="#939494"
          d="M 461.47556,52.132553 V 179.20736"
          id="path3276"

        />
        <Path
          strokeOpacity="1"
          strokeLinejoin="miter"
          strokeLinecap="butt"
          strokeWidth="1.00013375px"
          stroke="#ffffff"
          fillOpacity="1"
          fill="#939494"
          d="M 464,52.13447 V 179.21255"
          id="path3276-5"

        />
      </G>
    </Svg>

  );
}

export default CustomVanSVG;
